export default __webpack_public_path__ + "aa1451897a87fd57fa86cd80987f2a77.jpg";